<template>
  <div id="app" class="h-full">
    <router-view />
  </div>
</template>

<script>
import tokenJwt from "@/utils/token.js";

export default {
  name: "App",
  created: function() {
    //页面加载初始化store
    localStorage.getItem("store") &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem("store"))
        )
      );
    //页面刷新保存store
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state));
    });
    var path = window.location.pathname;
    var token = tokenJwt.getToken();
    if (path != "/login" && path != "/" && token) {
      //页面刷新立即刷新token
      this.$store.dispatch("refreshToken");
      //定时刷新token
      setInterval(_ => {
        this.$store.dispatch("refreshToken");
      }, 1140 * 1000);
    }
    // 获取医院列表
    this.$api.get('/HomePage/GetOrgInfo').then((rsp) => {
      if (rsp != false) {
        this.$store.commit('setHospitalList',rsp.data)
      }
    });
  },

  // mounted: function() {
  //   this.singleLoginRequest() 
  // },
  // methods:{
  //   singleLoginRequest(){
  //     let queryData = this.$route.query
  //     console.log(queryData)
  //     if(queryData.hasOwnProperty('open_id')&&queryData.hasOwnProperty('open_user_name')&&
  //       queryData.hasOwnProperty('platform_id')&&queryData.hasOwnProperty('app_id')&&queryData.hasOwnProperty('app_user_name')
  //       &&queryData.hasOwnProperty('timestamp')&&queryData.hasOwnProperty('ticket')&&queryData.hasOwnProperty('signature')) {
  //       this.$api.post(`/User/CheckUserContact`,{
  //         OpenID:queryData.open_id,
  //         OpenUserName:queryData.open_user_name,
  //         PlatformID:queryData.platform_id,
  //         AppID:queryData.app_id,
  //         AppUserName:queryData.app_user_name,
  //         TimeStamp:queryData.timestamp,
  //         Ticket:queryData.ticket,
  //         Signature:encodeURIComponent(queryData.signature)
  //       }).then(result=>{
  //         console.log(result)
  //         if(result.data){
  //           if(result.data.isNeedBindUser){
  //             this.AuthID=result.data.id
  //             this.singleLoginShow = true
  //           }else{
  //             if(result.data.access_token){
  //               this.$store.dispatch("bindingLogin",result.data).then((rsp) => {
  //                 if (rsp != false) {
  //                   //定时刷新token
  //                   setInterval((_) => {
  //                     this.$store.dispatch("refreshToken");
  //                   }, 1140 * 1000);
  //                   this.$router.push({ path: "/" });
  //                 }
  //               });
  //             }
  //           }
  //         }
  //       })
  //     }
  //   }
  // }
};
</script>

<style>
</style>